import React from "react";
import { Spinner, Callout } from "@blueprintjs/core";
import { useAuth } from "../../../auth/AuthContext";
import { useOrg } from "../../../auth/OrgContext";
import { useProjects } from "../../../auth/ProjectContext";
import { Link } from "react-router-dom";

export default function ProjectsPage() {
  const { tier, loading: authLoading } = useAuth();
  const { currentOrg, isLoading: orgLoading } = useOrg();
  const { projects, loading: projectsLoading } = useProjects();

  if (authLoading || orgLoading) {
    return (
      <div style={{ textAlign: "center", padding: "4rem" }}>
        <Spinner intent="primary" size={40} />
      </div>
    );
  }

  const hasSub = tier === "pro" || tier === "enterprise";

  if (!hasSub) {
    return (
      <div style={{ textAlign: "center", padding: "4rem" }}>
        <Callout
          title="Subscription required"
          intent="warning"
          style={{ marginBottom: "2rem", maxWidth: "600px", marginInline: "auto" }}
        >
          You need an active subscription to manage projects. <Link to="/account">Manage your plan&nbsp;→</Link>
        </Callout>
      </div>
    );
  }

  if (!currentOrg) {
    return (
      <div style={{ textAlign: "center", padding: "4rem" }}>
        <Callout
          title="No organization selected"
          intent="warning"
          style={{ marginBottom: "2rem", maxWidth: "600px", marginInline: "auto" }}
        >
          Please select or create an organization first. <a href="/account/organizations">Manage organizations&nbsp;→</a>
        </Callout>
      </div>
    );
  }

  return (
    <div style={{ maxWidth: 700, margin: "0 auto", padding: "2rem 0" }}>
      {projectsLoading ? (
        <Spinner size={20} />
      ) : projects && projects.length > 0 ? (
        <div style={{ color: "#888" }}>Select a project from the sidebar.</div>
      ) : (
        <div style={{ color: "#888" }}>No projects found.</div>
      )}
    </div>
  );
}
